<article>
  <header>
    <strong>TOP 5</strong>
    <app-secondary-button
      icon="assets/icons/common-download.svg"
      [color]="ButtonColorEnum.common"
      (clickFunc)="downloadTopFive()"
      [loading]="loadingDownloadTopFive"
      [enabled]="
        !loadingBestAttendants &&
        !loadingWorstAttendants &&
        !loadingResolutiveReasons &&
        !loadingUnresolvedReasons
      "
    ></app-secondary-button>
  </header>

  <main>
    <table>
      <thead>
        <tr>
          <th colspan="2">{{ title }}</th>
        </tr>
      </thead>
      <tr class="loadings">
        <td
          *ngIf="
            loadingBestAttendants ||
            loadingUnresolvedReasons ||
            loadingWorstAttendants ||
            loadingResolutiveReasons
          "
          class="loading"
        >
          <div class="loading-animation"></div>
        </td>
        <td
          class="error"
          *ngIf="
            errorBestAttendants ||
            errorUnresolvedReasons ||
            errorWorstAttendants ||
            errorResolutiveReasons
          "
        >
          <img src="assets/icons/error.svg" alt="" />
          <strong>Houve um problema ao processar os dados.</strong>
          <label>por favor tente novamente mais tarde.</label>
        </td>
      </tr>
      <tbody
        *ngIf="
          !loadingBestAttendants &&
          !loadingWorstAttendants &&
          !loadingResolutiveReasons &&
          !loadingUnresolvedReasons
        "
      >
        <tr *ngFor="let item of metricsData; let i = index">
          <td>{{ i + 1 }}º {{ item.name }}</td>
          <td>{{ parseFloat(item.quantity.toFixed(2)) }}%</td>
        </tr>
      </tbody>
    </table>
  </main>
</article>
